import { render, staticRenderFns } from "./ModuleNeedHelp.vue?vue&type=template&id=369508f6&scoped=true&"
import script from "./ModuleNeedHelp.vue?vue&type=script&lang=js&"
export * from "./ModuleNeedHelp.vue?vue&type=script&lang=js&"
import style0 from "./ModuleNeedHelp.vue?vue&type=style&index=0&id=369508f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369508f6",
  null
  
)

export default component.exports